import React from 'react';
import PropTypes from 'prop-types';
import { BreakpointsConsumer } from './BreakpointsProvider';

export default class OnWhen extends React.Component {
  static propTypes = {
    /** render when widthWindow > s (breakpoint) */
    defaultSize: PropTypes.bool,
    /** render when s <= widthWindow > m (breakpoint) */
    s: PropTypes.bool,
    /** render when m <= widthWindow > l (breakpoint) */
    m: PropTypes.bool,
    /** render widthWindow >= l (breakpoint) */
    l: PropTypes.bool,
    /** render when component application is server-side-rendered.
     * Note: Other size data may not be available when server-side-rendering.
     */
    ssr: PropTypes.bool,
    /** React Elements to be conditionally rendered based on window */
    children: PropTypes.any
  };

  static defaultProps = {
    defaultSize: false,
    s: false,
    m: false,
    l: false,
    ssr: false
  };

  render() {
    return (
      <BreakpointsConsumer>
        {breakpointsAndDims => {
          if (this.checkProps(breakpointsAndDims)) {
            return this.props.children;
          }
          return null;
        }}
      </BreakpointsConsumer>
    );
  }

  checkProps = ({ isS, isM, isL, isDefaultSize, isSsr }) => {
    const { defaultSize, s, m, l, ssr } = this.props;
    switch (true) {
      /* no size conditions are met */
      case !isS && !isM && !isL && !isDefaultSize && !isSsr:
        // todo: log, Breakpoints is not available or not functioning properly
        return true;
      /* no size props are specified */
      case !defaultSize && !s && !m && !l && !ssr:
        // todo: log, no sizes have been specified, if intentional use `On` component instead
        return true;
      case defaultSize && isDefaultSize:
        return true;
      case s && isS:
        return true;
      case m && isM:
        return true;
      case l && isL:
        return true;
      case ssr && isSsr:
        return true;
      default:
        return false;
    }
  };
}
